import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  makeStyles,
} from "@material-ui/core";
import { WarningOutlined } from "@material-ui/icons";

export interface WarningDialogProps {
  /** Controls whether the dialog is visible */
  open: boolean;
  /** Callback fired when the dialog is dismissed */
  onClose: () => void;
  /** Title text shown in the dialog header. Defaults to "Warning!" */
  title?: string;
  /** The message body displayed inside the dialog */
  message: string;
  /** Label for the dismiss button. Defaults to "Ok" */
  confirmLabel?: string;
  /** Accent / button colour (any valid CSS colour). Defaults to "#d32f2f" */
  color?: string;
}

const useStyles = makeStyles({
  dialogTitle: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    paddingBottom: 0,
  },
  errorIcon: {
    fontSize: 56,
    borderRadius: "50%",
    padding: 6,
    marginBottom: 8,
  },
  titleText: {
    fontWeight: "bold",
    fontSize: "1.2rem",
    color: "#1a1a1a",
  },
  dialogContent: {
    textAlign: "center",
    padding: "8px 24px 16px",
  },
  contentText: {
    color: "#333",
    fontSize: "0.95rem",
  },
  dialogActions: {
    justifyContent: "center",
    paddingBottom: 16,
  },
});

const WarningDialog: React.FC<WarningDialogProps> = ({
  open,
  onClose,
  title = "Warning!",
  message,
  confirmLabel = "Ok",
  color = "#d32f2f",
}) => {
  const classes = useStyles();


  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="warning-dialog-title"
      aria-describedby="warning-dialog-description"
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle id="warning-dialog-title" disableTypography className={classes.dialogTitle}>
        <WarningOutlined
          className={classes.errorIcon}
          style={{ color, border: `3px solid ${color}` }}
        />
        <span className={classes.titleText}>{title}</span>
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <DialogContentText id="warning-dialog-description" className={classes.contentText}>
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        <Button
          onClick={onClose}
          variant="contained"
          style={{
            backgroundColor: color,
            color: "#fff",
            paddingLeft: 32,
            paddingRight: 32,
          }}
        >
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};


export default WarningDialog;
